/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Duration_InvalidInputs */

const vi_error_irrigation_schedule_duration_invalid = /** @type {(inputs: Error_Irrigation_Schedule_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời lượng mỗi lần tưới phải từ 1 phút`)
};

/**

* @param {Error_Irrigation_Schedule_Duration_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_duration_invalid = /** @type {((inputs?: Error_Irrigation_Schedule_Duration_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Duration_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_duration_invalid(inputs)
});